<template>
  <div class="relative flex items-center justify-center">
    <img :src="user.urlProfilePhoto"
      class="rounded-lg w-full">
    <button class="absolute right-0 top-0 border border-white p-1 rounded"
      @click.prevent="openUploader">
      <edit-icon class="text-white w-7" />
    </button>
  </div>
</template>

<script>
import StreamFunctionsMixin from '@/mixins/StreamFunctionsMixin';
import EditIcon from './EditIcon.vue';

export default {
  props: ['givenUser'],

  components: {
    EditIcon,
  },

  mixins: [StreamFunctionsMixin],

  methods: {
    openUploader() {
      this.$emit('close');
      this.openImageModal(this.givenUser.id);
    },
  },
};
</script>
